import Lookup from 'src/componentes/select2';

const SeveridadeRiscoLookup = (props) => {
  return (
    <Lookup
      title="nome"
      labelKey="nome"
      valueKey="id"
      url={props.isLoading || props.options ? null : '/SeveridadeRiscoLookup'}
      ignoreURLWithOptions={true}
      clearable={false}
      {...props}
    />
  );
};

export default SeveridadeRiscoLookup;
